export default {
  "--color-primary": "rgb(193, 232, 77)",
  "--color-primary-active": "rgb(177, 226, 29)",
  "--color-primary-inverse": "rgb(12, 57, 68)",
  "--color-secondary": "rgb(233, 91, 95)",
  "--color-secondary-active": "rgb(230, 71, 76)",
  "--color-secondary-inverse": "rgb(255, 255, 255)",
  "--color-tertiary": "rgb(250, 222, 60)",
  "--color-tertiary-inverse": "rgb(12, 57, 68)",
  "--text-color-link": "rgb(193, 232, 77)",
  "--text-color-link-active": "rgb(177, 226, 29)",
  "--text-color-primary": "rgb(193, 232, 77)",
  "--text-color-primary-inverse": "rgb(12, 57, 68)",
  "--text-color-secondary": "rgb(233, 91, 95)",
  "--text-color-secondary-inverse": "rgb(255, 255, 255)",
  "--background-color-primary": "rgb(193, 232, 77)",
  "--background-color-primary-active": "rgb(177, 226, 29)",
  "--background-color-primary-inverse": "rgb(12, 57, 68)",
  "--background-color-secondary": "rgb(233, 91, 95)",
  "--background-color-secondary-active": "rgb(230, 71, 76)",
  "--background-color-secondary-inverse": "rgb(255, 255, 255)",
  "--background-input-base": "rgb(224, 228, 235)",
  "--border-color-active": "rgb(193, 232, 77)",
  "--border-color-primary": "rgb(193, 232, 77)"
};